import { nameof as _nameof } from './nameof.js';

export namespace Dom {
  const nameof = _nameof.prefix({ Dom });

  export function isAvailable() {
    return typeof window !== 'undefined';
  }

  export function assertIsAvailable() {
    if (!isAvailable()) throw new UnavailableError();
  }

  export class UnavailableError extends ReferenceError {
    static {
      this.prototype.name = nameof({ UnavailableError });
    }

    constructor() {
      super('DOM is not available in a SSR context!');
    }
  }
}
